import type { RestrictivePracticeType } from '@piccolohealth/pbs-common';
import React from 'react';
import { DeleteConfirmModal } from '../../../components/generic/DeleteConfirmModal';
import { createModal } from '../../../components/generic/Modal';
import { useDeleteParticipantRestrictivePracticeMutation } from '../../../graphql/hooks/useDeleteParticipantRestrictivePracticeMutation';
import { useAppContext } from '../../../hooks/useAppContext';
import { restrictivePracticeTypeOptions } from './RestrictivePracticeTypeTag';

interface Props {
  participantId: string;
  restrictivePracticeId: string;
  restrictivePracticeType: RestrictivePracticeType;
}

export const ParticipantRestrictivePracticeDeleteModal = createModal<Props>((props) => {
  const { participantId, restrictivePracticeId, restrictivePracticeType, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteParticipantRestrictivePracticeMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        restrictivePracticeId,
      })
      .then(async () => {
        successToast('Restrictive practice deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting restrictive practice: ${err.message}`);
      });
  }, [mutation, organization.id, participantId, restrictivePracticeId, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this restrictive practice?'
      confirmation={{
        level: 'Level2',
        confirm: restrictivePracticeTypeOptions[restrictivePracticeType].label,
      }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
